module.exports = __webpack_public_path__ + "static/media/Site_Gods.45721e85.jpg";